/**
 * NgwEditorView — `IEditorView` 의 NgwEditor 본 구현 (PR-N2).
 *
 * 사용자 결정 (b) — inline style 직접 조작 (re-render 회피 + undo 보존).
 *
 * 매핑 전략 (05 §4.7):
 *   - `setHeight(height)`: NgwEditor 의 outer wrapper `.ngw-editor-container` 의 style.height 를
 *     `${height}px` 로 설정. wrapper 가 없으면 mount element 자체에 fallback.
 *   - `setTextZoom(value)`: mount element 의 `style.fontSize = ${value * 100}%`. Safari 의 zoom
 *     CSS 호환성이 약하므로 fontSize 비율 (1.0 = 100%) 채택.
 *
 * NgwEditor `layout` prop 의 `!important` 충돌이 PoC 단계에서 확인되면 (b) 에서 (a)
 * lifecycle.requestRemount + layout prop 동적 변경 으로 fallback — 본 PR 단계는 (b) 우선.
 *
 * **init 전 safe noOp**: editor DOM 미존재 시 silent return.
 */

import type { IEditorView } from '../IEditorView'
import type { NgwEditorAdapter } from './NgwEditorAdapter'

const CONTAINER_CLASS = 'ngw-editor-container'

export class NgwEditorView implements IEditorView {
  private readonly adapter: NgwEditorAdapter

  constructor(adapter: NgwEditorAdapter) {
    this.adapter = adapter
  }

  setHeight(height: number): void {
    const dom = this.getEditorDOM()
    if (dom == null) {
      return
    }
    const wrapper = dom.closest<HTMLElement>(`.${CONTAINER_CLASS}`)
    const target = wrapper ?? dom
    target.style.height = `${height}px`
  }

  setTextZoom(value: number): void {
    const dom = this.getEditorDOM()
    if (dom == null) {
      return
    }
    dom.style.fontSize = `${value * 100}%`
  }

  private getEditorDOM(): HTMLElement | null {
    return this.adapter.lifecycle.getHandle()?.getEditorDOM() ?? null
  }
}
